<template>
    <div>
        <div style="margin: 0rem 0 0 0rem; border: 1px #DDDDDD solid;">
            <el-card class="box-card">
                <div slot="header">
                    <el-row style="margin-bottom: 20px">
                        <el-col :span="24">
                            <div style="line-height: 3rem; font-size: 1.5rem;">加班记录</div>
                        </el-col>

                    </el-row>
                    <el-row style="text-align: left">
                        <el-form :inline="true" :model="searchForm" @keyup.enter.native="searchData">
                            <el-form-item label="姓名">
                                <el-input @change="changeIndex"   placeholder="名称" v-model="searchForm.xm" prefix-icon="el-icon-user" clearable >
                                </el-input>
                            </el-form-item>
                            <el-form-item label="审核人">
                                <el-input @change="changeIndex"   placeholder="名称" v-model="searchForm.shrxm" prefix-icon="el-icon-user" clearable >
                                </el-input>
                            </el-form-item>
                            <el-form-item label="审批人">
                                <el-input @change="changeIndex"   placeholder="名称" v-model="searchForm.sprxm" prefix-icon="el-icon-user" clearable >
                                </el-input>
                            </el-form-item>
                            <el-form-item label="部门" >
                                <el-select @change="changeIndex"  clearable :disabled="deptdisable"  filterable   v-model="searchForm.bmid"  placeholder="请选择部门">
                                    <el-option
                                            v-for="item in depts"
                                            :key="item.bmid"
                                            :label="item.bmmc"
                                            :value="item.bmid"
                                            :disabled="deptdisable">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="开始时间">
                                <el-date-picker
                                        v-model="startTime"
                                        type="daterange"
                                        value-format="yyyy-MM-dd"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="状态">
                                <el-select v-model="searchForm.status" clearable @change="changeIndex"    placeholder="请选择状态">
                                    <el-option  :key="0" :label="'未审批'" :value="0"></el-option>
                                    <el-option  :key="1" :label="'审核不通过'" :value="1"></el-option>
                                    <el-option  :key="3" :label="'已审核'" :value="3"></el-option>
                                    <el-option  :key="2" :label="'已审批'" :value="2"></el-option>
                                    <el-option  :key="4" :label="'撤销'" :value="4"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="加班类型">
                                <el-select v-model="searchForm.jblx" clearable @change="changeIndex"    placeholder="请选择状态">
                                    <el-option
                                            v-for="item in jblxs"
                                            :key="item.dm"
                                            :label="item.mc"
                                            :value="item.dm"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button @click="searchData()">查询</el-button>
                            </el-form-item>
                        </el-form>
                    </el-row>
                </div>

                <el-table
                        :header-cell-class-name="handleHeaderClass"
                        @sort-change="handleTableSort"
                        :data="dataList"  v-loading="loading"  style="text-align: center; width: 100%;">
                    <el-table-column prop="workNumber" label="工号" >
                    </el-table-column>
                    <el-table-column prop="t.userid" label="姓名" sortable="custom">
                        <template slot-scope="scope">
                            {{scope.row.username}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="u.zzdyqc" label="部门" sortable="custom">
                        <template slot-scope="scope">
                            {{scope.row.bmmc}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="类型" prop="t.jblx" sortable="custom">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.jblx=='01'" type="info">{{scope.row.jblxmc}}</el-tag>
                            <el-tag v-else  type="success">{{scope.row.jblxmc}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" prop="t.status" sortable="custom">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status=='0'" type="danger">未审核</el-tag>
                            <el-tag v-else-if="scope.row.status=='1'" type="danger">审核不通过</el-tag>
                            <el-tag v-else-if="scope.row.status=='2'" type="success">已审批</el-tag>
                            <el-tag v-else-if="scope.row.status=='3'" type="success">已审核</el-tag>
                            <el-tag v-else type="info">已撤销</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="t.tjsj" label="申请时间" width="170" sortable="custom">
                        <template slot-scope="scope">
                            {{scope.row.tjsj}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="t.kssj" label="开始时间" width="170" sortable="custom">
                        <template slot-scope="scope">
                            {{scope.row.kssj}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="t.jssj" label="结束时间" width="200" sortable="custom">
                        <template slot-scope="scope">
                            {{scope.row.jssj}}
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" fixed="right" :render-header="renderHeader">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini"   @click="showInfo(scope.row)">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentNo"
                               :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
                </el-pagination>
            </el-card>
        </div>
        <el-dialog
                style="text-align: left"
                title="导出"
                :visible.sync="exportVisible"
        >
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <el-checkbox-group v-model="fieldList" @change="handleCheckedItemChange">
                <el-checkbox v-for="field in fields" :label="field.value" :key="field.value">{{field.name}}</el-checkbox>
            </el-checkbox-group>
            <form ref="exportForm" method="post" :action="this.$request.defaults.baseURL+'/bjba/kqshxx/exportJbExcel?access_token='+this.$store.getters.token"  target="_blank">
                <input type="hidden" v-for="(value,key,index) in searchForm" :name="key"  :value="value" />
                <input type="hidden" name="fileds" value="" ref="fileds"/>
            </form>
            <span slot="footer" class="dialog-footer">
    <el-button @click="exportVisible = false">取 消</el-button>
    <el-button type="primary" @click="exportExcel">确 定</el-button>
  </span>
        </el-dialog>
        <show-info v-if="showInfoVisible" ref="showInfo"></show-info>

    </div>
</template>
<script>
    import {
        Vue,
        Component
    } from 'vue-property-decorator'


    import ShowInfo from './jbxx-info'
    const exportFields=[
        {value:"username",name:"姓名"},
        {value:"workNumber",name:"工号"},
        {value:"bmmc",name:"部门"},
        {value:"jblxmc",name:"加班类型"},
        {value:"tjsj",name:"提交时间"},
        {value:"status",name:"状态"},
        {value:"kssj",name:"开始时间"},
        {value:"jssj",name:"结束时间"},
        {value:"jbsc",name:"加班时长"},
        {value:"shrxm",name:"审核人姓名"},
        {value:"shsj",name:"审核时间"},
        {value:"sprxm",name:"审批人姓名"},
        {value:"spsj",name:"审批时间"},
        {value:"jbsy",name:"加班事由"}

    ]
    @Component({
        name: 'salaryEmplae',
        components:{
            ShowInfo
        }
    })
    export default class salaryEmplae extends Vue {
        addOrUpdateVisible=false
        currentNo = 1;
        pageSize= 10;
        pageTotal = 0;
        dataList=[]
        orders=[]
        jblxs=[]

        showInfoVisible=false
        searchForm={
            xm:'',
            startTimest: '',
            startTimeed: '',
            bmid:'',
            shrxm:'',
            sprxm:'',
            status:'',
            jblx:''
        }
        deptdisable=false
        depts=[]
        startTime=[]
        loading = false;
        dataListSelections=[];
        isIndeterminate=false
        exportVisible=false
        checkAll=false
        fields=exportFields
        filedValues=exportFields.map(item => item.value)
        fieldList=[]
        created() {
          this.searchData();
            this.getDepts();
            this.getjblx();
        }

        handleSizeChange(val) {
            this.pageSize = val;
            this.searchData();
        }
        // 设置列的排序为我们自定义的排序
        handleHeaderClass({ column }) {
            if(!column.multiOrder) column.multiOrder =''
            column.order = column.multiOrder
        }
        handleOrderChange (orderColumn, orderState) {
            let result = this.orders.find(e => e.orderColumn === orderColumn)
            if (result) {
                if(orderState)
                    result.orderState = orderState
                else {
                    var j =this.orders.indexOf(result);
                    if(j !== -1) {
                        this.orders.splice(j,1);
                    }
                }
            } else {
                this.orders.push({
                    orderColumn: orderColumn,
                    orderState: orderState
                })
            }
            this.searchData()
        }
// 上面缺点是只能通过点击表头切换排序状态，点击小三角排序不会触发，处理sort-change事件和点击表头一样
// 列表排序
        handleTableSort({ column }) {
            console.log(column.orderfield)
            column.multiOrder = column.order
            this.handleOrderChange(column.property, column.multiOrder)
        }
        getParams() {

            if(this.startTime &&this.startTime.length==2){
                this.searchForm.startTimest = this.startTime[0]
                this.searchForm.startTimeed = this.startTime[1]
            } else{
                this.searchForm.startTimest = ''
                this.searchForm.startTimeed = ''
            }
            this.searchForm.page = this.currentNo;
            this.searchForm.pagesize = this.pageSize
            this.searchForm.orders = encodeURI(JSON.stringify(this.orders))
        }
        handleCheckAllChange(val) {
            this.fieldList = val ? this.filedValues: [];
            this.isIndeterminate = false;
        }
        handleCheckedItemChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.filedValues.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.fields.length;
        }

        showExportDialog() {
            this.exportVisible = true
        }
        renderHeader (h) {
            return (
                <div class="clearfix">
                    <span>操作</span>
                    <el-button style="padding:5px;float:right" size="mini"
                               onClick={()=>this.showExportDialog()}>导出</el-button></div>
            )
        }
        exportExcel() {
            var filedLast = this.fields.filter(filed=>{
                return this.fieldList.indexOf(filed.value) !==-1
            })
            if(filedLast && filedLast.length>0) {
                this.getParams();
                this.$refs.fileds.value = JSON.stringify(filedLast)
                this.$refs.exportForm.submit();
            } else {
                this.$message({
                    message: '请选择字段',
                    type: 'error',
                    duration: 1500
                })
                return
            }
        }
        getjblx() {
            let that = this;
            this.$request.get('/bjba/kqshxx/getAlljblx',{
            }).then(res => {
                that.jblxs = res.data.data
            })
        }
        getDepts() {
            let that = this;
            this.$request.get('/bjba/kqtj/getFirstMentForUser',{
                params: {
                    userid:this.$store.getters.username
                }

            }).then(res => {
                that.depts = res.data
            })
        }
        getbkbc(row) {
            var str =''
            if(row.data && row.bclx && row.dklx) {
                str = row.data;
                if(row.bclx =='1') str += "-早班"
                if(row.bclx =='2') str += "-中班"
                if(row.bclx =='3') str += "-夜班"
                if(row.dklx == '0') str += '-上班卡'
                if(row.dklx == '1') str += '-下班卡'
            }
            return str;
        }
        handleCurrentChange(val) {
            this.currentNo = val;
            this.searchData();
        }

        showInfo(val) {

            this.showInfoVisible = true
            this.$nextTick
            (() => {
                this.$refs.showInfo.init(val)
            })
        }
        changeIndex(){
            this.currentNo =1
        }
        searchData () {

            this.loading = true
            this.getParams()
            this.$request
                    .get('/bjba/kqshxx/jbPage',{params:this.searchForm})
                    .then(res => {
            const {data} = res
            this.loading = false
            this.dataList = data.data.content
            this.pageTotal = data.data.totalElements
            }).catch(err => {
            this.$message
            ({
            message: '获取列表出现异常!',
            type: 'error',
            center: true,
            showClose: true
            })
            this.loading = false
            console.log(err)
            })
        }
    }
</script>
<style lang="scss" scoped>
    .bcgl {}
</style>
